import React from 'react'
import './Product.css';
import { useStateValue } from '../../StateProvider';

function Product({ id, title, image, price, rating }) {
    const [state, dispatch] = useStateValue();
    
    const addToBasket = () => {
        
        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
                rating: rating,
            },
        });
    };

  return (
    <div className='product'>
        <div className='product_info'>
            <p>{title}</p>
            <p className='product_price'>
                <small>$</small>
                <strong>{price}</strong>
            </p>
            <div className='product_rating'>
                {Array(rating)
                .fill()
                .map((_, i) =>(
                    <span>⭐</span>
                ))}
            </div>
        </div>
        <img className='product_img' alt='product' src={image}/>
        <button onClick={addToBasket}>Add to basket</button>
    </div>
  )
}
export default Product